"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AppSettings_1 = tslib_1.__importDefault(require("../../apiServices/auth/AppSettings"));
var Types_1 = require("../../api/Types");
var ObjectType_1 = require("../../models/objects/ObjectType");
var SceModel_1 = require("../../models/SceModel");
var MappingModel_1 = require("../../models/mapping/MappingModel");
var Field_1 = require("../../constants/Field");
var DeepCopy_1 = require("../../models/common/lib/DeepCopy");
var Objects_1 = require("../../api/Objects");
var ExceptionHandler_1 = require("../../models/common/base/ExceptionHandler");
var ModelConstants_1 = require("../../constants/ModelConstants");
var lodash_1 = require("lodash");
var Draft_1 = require("../../models/drafts/Draft");
var Validator_1 = require("../../models/common/base/Validator");
var FunctionApis_1 = require("../../api/FunctionApis");
var Permissions_1 = require("../../apiServices/rbac/permissions/Permissions");
var PermissionsGroup_1 = require("../../apiServices/rbac/group/PermissionsGroup");
var SupportedModels_1 = require("../../models/supportedModels/SupportedModels");
var SceCompressedModel_1 = require("../../models/SceCompressedModel/SceCompressedModel");
var ModelBase_1 = require("../../models/ModelBase");
var Helper_1 = require("../Helper");
var ExportService_1 = require("../importExportService/ExportService");
var EngineeringModel_1 = require("../../api/enggModel/EngineeringModel");
var DataBuilder_1 = require("../../builder/DataBuilder");
var FunctioEndpointModels_1 = require("../../models/FunctioEndpointModels/FunctioEndpointModels");
var SceType = /** @class */ (function () {
    function SceType() {
        this._validator = new Validator_1.Validator();
        this._functionTypeApi = new FunctionApis_1.FunctionApis();
        this._objectsApi = new Objects_1.Objects();
        this._typesApi = new Types_1.Types();
        this._enggModelApi = new EngineeringModel_1.EngineeringModel();
    }
    //#region Public Methods
    SceType.prototype.getTypes = function (models) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var types, apiResponse, result, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        types = new Types_1.Types();
                        return [4 /*yield*/, types.getTypes(models)];
                    case 2:
                        apiResponse = _a.sent();
                        result = {
                            status: apiResponse.status,
                            details: apiResponse.data,
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_1 = _a.sent();
                        throw new Error(this.handleSceTypeError(error_1));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceType.prototype.getObjectTypeDetails = function (model, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var types, apiResponse, objectType, result, error_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        types = new Types_1.Types();
                        return [4 /*yield*/, types.getTypeDetails(model, typeId, version)];
                    case 2:
                        apiResponse = _a.sent();
                        objectType = ObjectType_1.ObjectType.fromJson(apiResponse.data);
                        result = {
                            status: apiResponse.status,
                            details: objectType.toJson(),
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_2 = _a.sent();
                        throw new Error(this.handleSceTypeError(error_2));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceType.prototype.saveModel = function (model, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sceModelType, saveOption, sceModel, mappingModel, result, result, error_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectCreateReadWriteTypeDefCreateReadWriteFileUploadDownloadSearch();
                        return [4 /*yield*/, this._validator.validate(model, false)];
                    case 1:
                        _a.sent();
                        if (model.properties.model.model.value ===
                            ModelConstants_1.ModelConstants.AssetCriticalityModel) {
                            throw new Error("Forbidden: Cannot create or update an Asset Criticality Type");
                        }
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 7, , 8]);
                        sceModelType = model;
                        saveOption = sceModelType.properties.saveOption.value;
                        sceModel = SceModel_1.SceModel.fromJson(model, false);
                        return [4 /*yield*/, sceModel.properties.fetchMappings()];
                    case 3:
                        mappingModel = _a.sent();
                        if (!sceModelType.objectId) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.updateModel(saveOption, model, sceModel, mappingModel, isCod)];
                    case 4:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 5:
                        result = this.createModel(saveOption, model, sceModel, mappingModel);
                        return [2 /*return*/, result];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_3 = _a.sent();
                        throw new Error(this.handleSceTypeError(error_3));
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    SceType.prototype.getModels = function (typeId, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var objects, mappingsResponse, mappings, mappingModels, _a, modelsObjectsInfo, draftsObjectsInfo, sceModels, draftModels, models, error_4;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectReadFileDownloadSearch();
                        objects = new Objects_1.Objects();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, objects.getMappingsContainingTypeId(ModelConstants_1.ModelConstants.MappingModel, typeId)];
                    case 2:
                        mappingsResponse = _b.sent();
                        mappings = mappingsResponse.data.data;
                        if (mappings.length === 0) {
                            return [2 /*return*/, this.createSceModelListResult([])];
                        }
                        mappingModels = lodash_1.map(mappings, function (mappingFile) { return MappingModel_1.MappingModel.fromJson(mappingFile); });
                        return [4 /*yield*/, this.fetchModelsForMappingFiles(mappingModels)];
                    case 3:
                        _a = _b.sent(), modelsObjectsInfo = _a[0], draftsObjectsInfo = _a[1];
                        return [4 /*yield*/, this.fetchSceModels(modelsObjectsInfo, isCod)];
                    case 4:
                        sceModels = _b.sent();
                        return [4 /*yield*/, this.fetchDraftModels(draftsObjectsInfo)];
                    case 5:
                        draftModels = _b.sent();
                        models = sceModels.concat(draftModels);
                        return [2 /*return*/, this.createSceModelListResult(models)];
                    case 6:
                        error_4 = _b.sent();
                        throw new Error(this.handleSceTypeError(error_4));
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    SceType.prototype.deleteModel = function (model, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, typeId, version, modelStatistics, isDeletable, exceptionHandler, sceModelType, sceModel, mappingModel, result, error_5;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectReadWriteDeleteFileUploadDownloadSearchDelete();
                        if (model.properties.model.model.value ===
                            ModelConstants_1.ModelConstants.AssetCriticalityModel) {
                            throw new Error("Forbidden: Cannot delete an Asset Criticality Type");
                        }
                        _a = model.properties.model, typeId = _a.typeId, version = _a.version;
                        return [4 /*yield*/, this.getModelStatistics(1, 10, typeId.value, parseInt(version.value.split(".")[0], 10))];
                    case 1:
                        modelStatistics = _b.sent();
                        isDeletable = modelStatistics.details.data
                            ? modelStatistics.details.data.length === 0
                            : true;
                        if (!isDeletable) {
                            throw new Error("Model cannot be deleted. It is being used by an instance.");
                        }
                        exceptionHandler = new ExceptionHandler_1.ExceptionHandler();
                        if (!model.objectId) {
                            throw new Error(exceptionHandler.buildExceptionFromErrorMessage("Bad request", 400, "Validation error", "#.objectId is undefined"));
                        }
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 5, , 6]);
                        sceModelType = model;
                        sceModel = SceModel_1.SceModel.fromJson(model, false);
                        return [4 /*yield*/, sceModel.properties.fetchMappings()];
                    case 3:
                        mappingModel = _b.sent();
                        if (mappingModel.objectId) {
                            // Check if fetchMappings() has not returned a newly created mappings
                            mappingModel.properties.removeType(sceModelType.objectId);
                        }
                        else {
                            throw new Error("Delete Error: Failed to fetch mappings for typeId: " +
                                sceModel.properties.associatedObjectType.typeId.value);
                        }
                        return [4 /*yield*/, this.deleteModelWithRelatedType(sceModel, mappingModel, isCod)];
                    case 4:
                        result = _b.sent();
                        return [2 /*return*/, result];
                    case 5:
                        error_5 = _b.sent();
                        throw new Error(this.handleSceTypeError(error_5));
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    SceType.prototype.getSupportedModels = function (excludeEngineeringData) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var cmSupportedModelsResponse, response, funcReponse, supportedModelInstance, supportedModels, error_6;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectReadTypeDefRead();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 16, , 17]);
                        if (!(excludeEngineeringData === false)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.createSceRestoreData()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this._objectsApi.queryForModel(ModelConstants_1.ModelConstants.SupportedConditionMonitorModels)];
                    case 4:
                        cmSupportedModelsResponse = _a.sent();
                        if (!(cmSupportedModelsResponse.data.data.length === 0)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.initiateSupportedConditionsModelsSetup()];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [4 /*yield*/, this._objectsApi.queryForModel(ModelConstants_1.ModelConstants.SupportedModels)];
                    case 7:
                        response = _a.sent();
                        if (!(response.data.data.length === 0)) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.initiateSupportedModelsSetup()];
                    case 8:
                        _a.sent();
                        return [4 /*yield*/, this._objectsApi.queryForModel(ModelConstants_1.ModelConstants.SupportedModels)];
                    case 9:
                        response = _a.sent();
                        _a.label = 10;
                    case 10: return [4 /*yield*/, this._objectsApi.queryForModel(ModelConstants_1.ModelConstants.FunctionEndPointModels)];
                    case 11:
                        funcReponse = _a.sent();
                        if (!(funcReponse.data.data.length === 0)) return [3 /*break*/, 13];
                        return [4 /*yield*/, this.initiateFunctionEndpointModelsSetup()];
                    case 12:
                        _a.sent();
                        _a.label = 13;
                    case 13:
                        if (!(excludeEngineeringData === false)) return [3 /*break*/, 15];
                        return [4 /*yield*/, this.initiateMappingsSetup()];
                    case 14:
                        _a.sent();
                        _a.label = 15;
                    case 15:
                        supportedModelInstance = response.data.data[0];
                        supportedModels = supportedModelInstance
                            ? supportedModelInstance[Field_1.FIELD.PROPERTIES][Field_1.FIELD.SUPPORTEDMODELS]
                            : {};
                        return [2 /*return*/, {
                                details: supportedModels,
                                status: 200,
                            }];
                    case 16:
                        error_6 = _a.sent();
                        throw new Error(this.handleSceTypeError(error_6));
                    case 17: return [2 /*return*/];
                }
            });
        });
    };
    SceType.prototype.getModelStatistics = function (pageNumber, pageSize, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var type, objects, response, result, error_7;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyObjectReadPermission();
                        type = typeId + "@" + version;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        objects = new Objects_1.Objects();
                        return [4 /*yield*/, objects.getInstanceInformationForModelType(pageNumber, pageSize, type)];
                    case 2:
                        response = _a.sent();
                        result = {
                            status: response.status,
                            details: response.data,
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_7 = _a.sent();
                        throw new Error(this.handleSceTypeError(error_7));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceType.prototype.getTypesVersions = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var types, mapPromises, response, result;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        types = new Types_1.Types();
                        mapPromises = lodash_1.map(data, function (modelInfo) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var modelId, typeId, response, modeldef;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        modelId = modelInfo.modelId, typeId = modelInfo.typeId;
                                        return [4 /*yield*/, types.getTypeVersions(modelId, typeId)];
                                    case 1:
                                        response = _a.sent();
                                        modeldef = {
                                            modelId: modelId,
                                            typeId: typeId,
                                            versions: response.data.versions,
                                        };
                                        return [2 /*return*/, modeldef];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(mapPromises)];
                    case 1:
                        response = _a.sent();
                        result = {
                            status: 200,
                            details: response,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.getTypeVersions = function (data, filterByMajorVersion) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var modelId, typeId, types, response, versions, majorVersions_1, filteredVersions, result, error_8;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        modelId = data.modelId, typeId = data.typeId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        types = new Types_1.Types();
                        return [4 /*yield*/, types.getTypeVersions(modelId, typeId)];
                    case 2:
                        response = _a.sent();
                        versions = response.data.versions;
                        if (filterByMajorVersion !== undefined && filterByMajorVersion === true) {
                            majorVersions_1 = [];
                            filteredVersions = lodash_1.filter(versions, function (version) {
                                var majorVersion = version.split('.')[0];
                                if (majorVersions_1.includes(majorVersion)) {
                                    return false;
                                }
                                majorVersions_1.push(majorVersion);
                                return true;
                            });
                            versions = filteredVersions;
                        }
                        result = {
                            status: 200,
                            details: versions,
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_8 = _a.sent();
                        throw new Error("Failed to fetch versions. Error: " + this.handleSceTypeError(error_8));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceType.prototype.getTenantSpecificType = function (modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        return [4 /*yield*/, this._typesApi.getTenantBasedTypeDetails(modelId, typeId, version)];
                    case 1:
                        response = _a.sent();
                        result = {
                            status: 200,
                            details: response.data,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.importModels = function (zippedModels, parentObjectType, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tenantSpecificZippedModels, summary, mapPromises;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectCreateReadWriteTypeDefCreateReadWriteFileUploadDownloadSearch();
                        lodash_1.map(zippedModels, function (zippedModel) {
                            if (zippedModel.model.properties.model.model.value ===
                                ModelConstants_1.ModelConstants.AssetCriticalityModel) {
                                throw new Error("Forbidden: Cannot import an Asset Criticality Type");
                            }
                        });
                        tenantSpecificZippedModels = lodash_1.map(zippedModels, function (zippedModel) {
                            return _this.getTenantSpecificZippedModel(zippedModel);
                        });
                        summary = {
                            successDetails: [],
                            failureDetails: [],
                        };
                        mapPromises = lodash_1.map(tenantSpecificZippedModels, function (zippedModel, modelIndex) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var model, sceModel, associatedObjectType, hasDependancyError, summaryDetailsReason, summaryStatus, dataOut, isAlike, failReason, dataInModel_1, summaryDetails_1, functionTypes, uniqueFunctionTypes, functionTypePromises, failReason, dataInModel_2, summaryDetails_2, reason, status, output, dataInModel, input, saveResponse, summaryDetails;
                            var _this = this;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        model = zippedModel.model;
                                        sceModel = SceModel_1.SceModel.fromJson(model, false);
                                        associatedObjectType = sceModel.properties.associatedObjectType;
                                        hasDependancyError = false;
                                        summaryDetailsReason = [];
                                        summaryStatus = "Failure";
                                        dataOut = {};
                                        isAlike = associatedObjectType.isAlike(parentObjectType);
                                        if (!isAlike) {
                                            summaryDetailsReason = [
                                                "Associated Object Type for model " + sceModel.properties.model.name.value + " doesn't match with the Object Type under which it is being imported",
                                            ];
                                            hasDependancyError = true;
                                        }
                                        if (hasDependancyError) {
                                            failReason = [
                                                "Saving this model is avoided due to mismatch in its associated object type",
                                            ];
                                            summaryDetailsReason = summaryDetailsReason.concat(failReason);
                                            dataInModel_1 = model.properties.model;
                                            summaryDetails_1 = {
                                                dataIn: {
                                                    model: dataInModel_1.model.value,
                                                    typeId: dataInModel_1.typeId.value,
                                                    name: dataInModel_1.name.value,
                                                    version: dataInModel_1.version.value,
                                                },
                                                status: summaryStatus,
                                                reason: summaryDetailsReason,
                                                dataOut: dataOut,
                                            };
                                            summary.failureDetails.push(summaryDetails_1);
                                            return [2 /*return*/];
                                        }
                                        functionTypes = zippedModel.functionTypes;
                                        uniqueFunctionTypes = this.getUniqueFunctionTypes(functionTypes);
                                        functionTypePromises = lodash_1.map(uniqueFunctionTypes, function (functionType, index) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                            var modelId, types, verificationResult, functionTypeResponse;
                                            var _this = this;
                                            return tslib_1.__generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0:
                                                        if (hasDependancyError) {
                                                            summaryDetailsReason = summaryDetailsReason.concat("Cannot save function type " + functionType[Field_1.FIELD.NAME] + " as one of the dependancies is failed to save for this model");
                                                            return [2 /*return*/];
                                                        }
                                                        modelId = functionType[Field_1.FIELD.MODEL];
                                                        types = new Types_1.Types();
                                                        return [4 /*yield*/, types.verifyModelUniqueness(modelId, functionType[Field_1.FIELD.TYPEID], functionType[Field_1.FIELD.VERSION], ModelConstants_1.ModelConstants.AssetMonitorModel)];
                                                    case 1:
                                                        verificationResult = _a.sent();
                                                        if (!(verificationResult.isUnique && !verificationResult.isDeleted)) return [3 /*break*/, 3];
                                                        delete functionType[Field_1.FIELD.ISDELETED];
                                                        return [4 /*yield*/, this._functionTypeApi
                                                                .saveFunction(modelId, functionType)
                                                                .catch(function (error) {
                                                                summaryDetailsReason = summaryDetailsReason.concat("Failed to save function type " + functionType[Field_1.FIELD.NAME] + ". " + _this.handleServerError(error));
                                                                hasDependancyError = true;
                                                            })];
                                                    case 2:
                                                        functionTypeResponse = _a.sent();
                                                        if (functionTypeResponse) {
                                                            summaryDetailsReason = summaryDetailsReason.concat("Function type " + functionType[Field_1.FIELD.NAME] + " is saved successfully. ");
                                                        }
                                                        return [3 /*break*/, 4];
                                                    case 3:
                                                        if (!verificationResult.isUnique &&
                                                            !verificationResult.isDeleted) {
                                                            summaryDetailsReason = summaryDetailsReason.concat("Function type " + functionType[Field_1.FIELD.NAME] + " with typeId " + functionType[Field_1.FIELD.TYPEID] + " and version " + functionType[Field_1.FIELD.VERSION] + " is already available. So avoiding resave.");
                                                        }
                                                        else if (verificationResult.isDeleted) {
                                                            summaryDetailsReason = summaryDetailsReason.concat("Cannot save function type " + functionType[Field_1.FIELD.NAME] + " with typeId " + functionType[Field_1.FIELD.TYPEID] + " and version " + functionType[Field_1.FIELD.VERSION] + " as it is marked as deleted.");
                                                            hasDependancyError = true;
                                                        }
                                                        _a.label = 4;
                                                    case 4: return [2 /*return*/];
                                                }
                                            });
                                        }); });
                                        return [4 /*yield*/, Promise.all(functionTypePromises)];
                                    case 1:
                                        _a.sent();
                                        if (!hasDependancyError) {
                                            summaryStatus = "Success";
                                        }
                                        else {
                                            failReason = [
                                                "Saving this model is avoided as one of its functionType dependencies is not saved properly.",
                                            ];
                                            summaryStatus = "Failure";
                                            summaryDetailsReason = failReason.concat(summaryDetailsReason);
                                            dataInModel_2 = model.properties.model;
                                            summaryDetails_2 = {
                                                dataIn: {
                                                    model: dataInModel_2.model.value,
                                                    typeId: dataInModel_2.typeId.value,
                                                    name: dataInModel_2.name.value,
                                                    version: dataInModel_2.version.value,
                                                },
                                                status: summaryStatus,
                                                reason: summaryDetailsReason,
                                                dataOut: dataOut,
                                            };
                                            summary.failureDetails.push(summaryDetails_2);
                                            return [2 /*return*/];
                                        }
                                        delete model[Field_1.FIELD.OBJECTID];
                                        delete model[Field_1.FIELD.VERSION];
                                        delete model[Field_1.FIELD.LASTMODIFIED];
                                        reason = [];
                                        status = "Failure";
                                        output = {};
                                        dataInModel = model.properties.model;
                                        input = {
                                            model: dataInModel.model.value,
                                            typeId: dataInModel.typeId.value,
                                            name: dataInModel.name.value,
                                            version: dataInModel.version.value,
                                        };
                                        return [4 /*yield*/, this.saveModel(model, isCod).catch(function (error) {
                                                summaryDetailsReason = summaryDetailsReason.concat("Failed to save model " + model.properties.model.name.value + " " + _this.handleServerError(error));
                                            })];
                                    case 2:
                                        saveResponse = _a.sent();
                                        if (saveResponse) {
                                            reason = summaryDetailsReason.concat("Saved model " + model.properties.model.name.value + " successfully");
                                            status = "Success";
                                            output = saveResponse.details;
                                        }
                                        else {
                                            reason = summaryDetailsReason.concat("Failed to save model " + model.properties.model.name.value);
                                            status = "Failure";
                                        }
                                        summaryDetails = {
                                            dataIn: input,
                                            status: status,
                                            reason: reason,
                                            dataOut: output,
                                        };
                                        if (summaryDetails.status === "Success") {
                                            summary.successDetails.push(summaryDetails);
                                        }
                                        else {
                                            summary.failureDetails.push(summaryDetails);
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(mapPromises)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, summary];
                }
            });
        });
    };
    SceType.prototype.createExportableModels = function (models) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var exportService, modelsClone, summary, mapPromises;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectReadFileDownloadSearch();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        exportService = new ExportService_1.ExportService();
                        return [4 /*yield*/, exportService.getUniqueModelsWithReferencedTypes(DeepCopy_1.deepCopy(models))];
                    case 1:
                        modelsClone = _a.sent();
                        summary = {
                            successDetails: [],
                            failureDetails: [],
                        };
                        mapPromises = lodash_1.map(modelsClone, function (model) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var sceModel, properties, functionTypes, dataOut, summaryDetailsReason, hasFunctionFetchError, functionTypesPromises, summaryDetails;
                            var _this = this;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        sceModel = SceModel_1.SceModel.fromJson(model, false);
                                        properties = sceModel.properties;
                                        functionTypes = [];
                                        dataOut = { functionTypes: [], model: {} };
                                        summaryDetailsReason = [];
                                        hasFunctionFetchError = false;
                                        functionTypesPromises = lodash_1.map(properties.functions, function (sceFunction, index) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                            var functionType, data;
                                            var _this = this;
                                            return tslib_1.__generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4 /*yield*/, sceFunction
                                                            .fetchFunctionType()
                                                            .catch(function (error) {
                                                            summaryDetailsReason = summaryDetailsReason.concat("Error fetching function type. " + _this.handleServerError(error) + " ");
                                                            hasFunctionFetchError = true;
                                                        })];
                                                    case 1:
                                                        functionType = _a.sent();
                                                        if (functionType) {
                                                            data = functionType.data;
                                                            delete data[Field_1.FIELD.ISDELETED];
                                                            functionTypes.push(data);
                                                            summaryDetailsReason = summaryDetailsReason.concat("Fetched dependent function successfully ");
                                                        }
                                                        return [2 /*return*/];
                                                }
                                            });
                                        }); });
                                        return [4 /*yield*/, Promise.all(functionTypesPromises)];
                                    case 1:
                                        _a.sent();
                                        delete model[Field_1.FIELD.VERSION];
                                        delete model[Field_1.FIELD.LASTMODIFIED];
                                        delete model[Field_1.FIELD.OBJECTID];
                                        dataOut.functionTypes = functionTypes;
                                        dataOut.model = model;
                                        summaryDetails = {
                                            status: hasFunctionFetchError ? "Failure" : "Success",
                                            reason: summaryDetailsReason,
                                            dataIn: {
                                                name: model.properties.model.name.value,
                                                model: model.properties.model.model.value,
                                                typeId: model.properties.model.typeId.value,
                                                version: model.properties.model.version.value,
                                            },
                                            dataOut: dataOut,
                                        };
                                        if (summaryDetails.status === "Success") {
                                            summary.successDetails.push(summaryDetails);
                                        }
                                        else {
                                            summary.failureDetails.push(summaryDetails);
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(mapPromises)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, summary];
                }
            });
        });
    };
    SceType.prototype.createImportableModel = function (zippedModel, targetAssociatedObjectType) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tenantSpecificZippedModel, sceModel, modelBase, clone, model, modifiedModel;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        tenantSpecificZippedModel = this.getTenantSpecificZippedModel(zippedModel);
                        sceModel = DeepCopy_1.deepCopy(tenantSpecificZippedModel.model);
                        modelBase = ModelBase_1.ModelBase.fromJson(sceModel.properties.associatedObjectType);
                        if (modelBase.isAlike(targetAssociatedObjectType)) {
                            sceModel.properties.associatedObjectType = targetAssociatedObjectType;
                            clone = DeepCopy_1.deepCopy(tenantSpecificZippedModel);
                            clone.model = sceModel;
                            return [2 /*return*/, clone];
                        }
                        return [4 /*yield*/, SceModel_1.SceModel.updateConnections(sceModel, targetAssociatedObjectType)];
                    case 1:
                        model = _a.sent();
                        modifiedModel = {
                            model: model,
                            functionTypes: tenantSpecificZippedModel.functionTypes,
                        };
                        return [2 /*return*/, modifiedModel];
                }
            });
        });
    };
    SceType.prototype.getAlarmType = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var AlarmDefModel, AlarmDefTypeId, types, response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        AlarmDefModel = ModelConstants_1.ModelConstants.AlarmDefModel, AlarmDefTypeId = ModelConstants_1.ModelConstants.AlarmDefTypeId;
                        types = new Types_1.Types();
                        return [4 /*yield*/, types.getLatestType(AlarmDefModel, AlarmDefTypeId)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: [response.data.content],
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Gets Sce Model
     * @param modelId asset monitor modelId
     * @param typeId asset monitor typeId
     * @param version asset monitor version (Kept unaltered for future use)
     * @param isCod Is Connect on Demand Mode
     */
    SceType.prototype.getType = function (modelId, typeId, version, objectId, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sceModel, compressedModel, sceCompressedModel, _a, compressedModels, compressedModel, sceCompressedModel, result, error_9;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectReadFileDownloadSearch();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 7, , 8]);
                        sceModel = void 0;
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 6]);
                        return [4 /*yield*/, this._enggModelApi.GetEnggModel(objectId, ModelConstants_1.ModelConstants.SceModel)];
                    case 3:
                        compressedModel = _b.sent();
                        sceCompressedModel = SceCompressedModel_1.SceCompressedModel.fromJson(compressedModel.data, false);
                        sceModel = sceCompressedModel.properties.getUncompressedModel(modelId);
                        return [3 /*break*/, 6];
                    case 4:
                        _a = _b.sent();
                        return [4 /*yield*/, this._objectsApi.queryForCompressedModelWithAssetMonitor(ModelConstants_1.ModelConstants.SceModel, modelId, typeId)];
                    case 5:
                        compressedModels = _b.sent();
                        if (compressedModels.data.data.length !== 0) {
                            compressedModel = compressedModels.data.data[0];
                            sceCompressedModel = SceCompressedModel_1.SceCompressedModel.fromJson(compressedModel, false);
                            sceModel = sceCompressedModel.properties.getUncompressedModel(modelId);
                        }
                        else {
                            if (isCod) {
                                throw new Error("Type not found");
                            }
                            sceModel = {};
                        }
                        return [3 /*break*/, 6];
                    case 6:
                        result = {
                            details: sceModel,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                    case 7:
                        error_9 = _b.sent();
                        throw new Error(this.handleSceTypeError(error_9));
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    SceType.prototype.getEnggSceModels = function (models) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sceModel_1, modalKeyVal_1, response, result, error_10;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectReadFileDownloadSearch();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        sceModel_1 = [];
                        modalKeyVal_1 = [];
                        models.forEach(function (modalData) {
                            modalKeyVal_1.push({
                                key: modalData.key,
                                value: ModelConstants_1.ModelConstants.SceModel
                            });
                        });
                        return [4 /*yield*/, this._typesApi.getEnggsSceModels(modalKeyVal_1)];
                    case 2:
                        response = _a.sent();
                        if (response) {
                            response.data.forEach(function (compressedModel) {
                                var sceCompressedModel = SceCompressedModel_1.SceCompressedModel.fromJson(compressedModel, false);
                                var modalIds = models.find(function (modalIdData) {
                                    return compressedModel.objectId == modalIdData.key;
                                });
                                if (modalIds) {
                                    var sceConstantModel = sceCompressedModel.properties.getUncompressedModel(modalIds.value);
                                    sceModel_1.push(sceConstantModel);
                                }
                            });
                        }
                        result = {
                            details: sceModel_1,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_10 = _a.sent();
                        throw new Error(this.handleSceTypeError(error_10));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceType.prototype.getTypeDefinition = function (modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        return [4 /*yield*/, this._typesApi.getTypeDetails(modelId, typeId, version)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.getSupportedConditionMonitorModels = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, modelIds, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyObjectReadPermission();
                        return [4 /*yield*/, this._objectsApi.queryForModel(ModelConstants_1.ModelConstants.SupportedConditionMonitorModels)];
                    case 1:
                        response = _a.sent();
                        if (response.data.data.length === 0) {
                            throw new Error("Model Ids are not available");
                        }
                        modelIds = response.data.data[0]
                            .properties.supportedModels.value;
                        result = {
                            details: modelIds,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.getTypeVariables = function (model, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var types, apiResponse, objectType, result, error_11;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        types = new Types_1.Types();
                        return [4 /*yield*/, types.getTypeVariables(model, typeId, version)];
                    case 2:
                        apiResponse = _a.sent();
                        objectType = ObjectType_1.ObjectType.fromJson(apiResponse.data);
                        result = {
                            status: apiResponse.status,
                            details: objectType.toJson(),
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_11 = _a.sent();
                        throw new Error(this.handleSceTypeError(error_11));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceType.prototype.getModelDefinition = function (modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefWritePermission();
                        return [4 /*yield*/, this._typesApi.getModelDefinition(modelId)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.getSupportedCondintionModelList = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefWritePermission();
                        return [4 /*yield*/, this._typesApi.getSupportedCondintionModelList()];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.getSupportedCondintionModelWithTenantInfo = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, supportedModelsWithTenantInfo, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefWritePermission();
                        return [4 /*yield*/, this.getSupportedCondintionModelList()];
                    case 1:
                        response = _a.sent();
                        supportedModelsWithTenantInfo = [];
                        if (response && Array.isArray(response.details))
                            response.details.forEach(function (model) {
                                var modelInfo = {
                                    modelName: model.modelId,
                                    tenant: model["tags"] ? (Array.isArray(model.tags) ? Helper_1.Helper.validateTypeForTenantTags(model.tags) : false) : false
                                };
                                supportedModelsWithTenantInfo.push(modelInfo);
                            });
                        result = {
                            details: supportedModelsWithTenantInfo,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.addNewConditionMonitorModels = function (modelList) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefWritePermission();
                        return [4 /*yield*/, this._typesApi.addSupportedModels(modelList)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.updateConditionMonitorModels = function (modelList) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefWritePermission();
                        return [4 /*yield*/, this._typesApi.updateConditionMonitorModels(modelList)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.removeConditionMonitorModels = function (modelIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefWritePermission();
                        return [4 /*yield*/, this._typesApi.removeConditionMonitorModels(modelIds)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.getLatestFunctionsForType = function (modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, functionTypes, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        return [4 /*yield*/, this._typesApi.getLatestFunctionsForType(modelId, typeId, version)];
                    case 1:
                        response = _a.sent();
                        functionTypes = lodash_1.map(response.data, function (o) { return DataBuilder_1.DataBuilder.buildFunctionType(o); });
                        result = {
                            details: functionTypes,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.getFunctionVersionsForType = function (modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        return [4 /*yield*/, this._typesApi.getFunctionVersionsForType(modelId, typeId, version)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.getAssetMonitorTypesInfoForFunctionType = function (functionTypeId, functionVersion) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        return [4 /*yield*/, this._typesApi.getAssetMonitorTypesInfoForGivenFunctionType(functionTypeId, functionVersion)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.verifyTypeExists = function (modelId, typeId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        return [4 /*yield*/, this._typesApi.verifyTypeExists(modelId, typeId)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.getModelsAndTypesBySCEModelIdWithTypeInfo = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        return [4 /*yield*/, this._typesApi.getModelsAndTypesBySCEModelIdWithTypeInfo()];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.getVariablesAlarmsAndEvents = function (modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        return [4 /*yield*/, this._typesApi.getVariablesAlarmsAndEvents(modelId, typeId, version)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.getAllModels = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        return [4 /*yield*/, this._typesApi.getAllModels()];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.getFunctionEndpointList = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        return [4 /*yield*/, this._typesApi.getFunctionEndpointList()];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.addFunctionEndpoint = function (endPoint) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        return [4 /*yield*/, this._typesApi.addFunctionEndpoint(endPoint)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.deleteFunctionEndpoint = function (endPoint) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        return [4 /*yield*/, this._typesApi.deleteFunctionEndpoint(endPoint)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    //#endregion
    //#region Private Methods
    SceType.prototype.createSceRestoreData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._objectsApi.createSceRestoreData()];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SceType.prototype.initiateSupportedModelsSetup = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var types, supportedModelsType, supportedModelContent;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        Permissions_1.rbacPermissions.verifyObjectWritePermission();
                        types = new Types_1.Types();
                        return [4 /*yield*/, types.getLatestType(ModelConstants_1.ModelConstants.SupportedModels, ModelConstants_1.ModelConstants.SupportedModelsTypeId)];
                    case 1:
                        supportedModelsType = _a.sent();
                        supportedModelContent = supportedModelsType.data
                            .content;
                        return [4 /*yield*/, SupportedModels_1.SupportedModelsType.fromJson(supportedModelContent).saveSupportedModels(false)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SceType.prototype.initiateSupportedConditionsModelsSetup = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var cmSupportedModelsResponse, types, supportedCMModelsType, supportedModelContent;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        Permissions_1.rbacPermissions.verifyObjectWritePermission();
                        return [4 /*yield*/, this._objectsApi.queryForModel(ModelConstants_1.ModelConstants.SupportedConditionMonitorModels)];
                    case 1:
                        cmSupportedModelsResponse = _a.sent();
                        if (cmSupportedModelsResponse.data.data.length > 0) {
                            return [2 /*return*/];
                        }
                        types = new Types_1.Types();
                        return [4 /*yield*/, types.getLatestType(ModelConstants_1.ModelConstants.SupportedConditionMonitorModels, ModelConstants_1.ModelConstants.supportedConditionMonitorModelsTypeId)];
                    case 2:
                        supportedCMModelsType = _a.sent();
                        supportedModelContent = supportedCMModelsType.data
                            .content;
                        return [4 /*yield*/, SupportedModels_1.SupportedModelsType.fromJson(supportedModelContent).saveSupportedModels(true)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SceType.prototype.initiateFunctionEndpointModelsSetup = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var types, functionEndpointModelsType, functionEndpointModelsTypeContent;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        Permissions_1.rbacPermissions.verifyObjectWritePermission();
                        types = new Types_1.Types();
                        return [4 /*yield*/, types.getLatestType(ModelConstants_1.ModelConstants.FunctionEndPointModels, ModelConstants_1.ModelConstants.FunctionEndPointModelsTypeId)];
                    case 1:
                        functionEndpointModelsType = _a.sent();
                        functionEndpointModelsTypeContent = functionEndpointModelsType.data
                            .content;
                        return [4 /*yield*/, FunctioEndpointModels_1.FunctionEndpointModelsType.fromJson(functionEndpointModelsTypeContent).saveFunctionEndpointModels(true)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SceType.prototype.initiateMappingsSetup = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mappings, infoModelCriticalityModels, criticalityCompressedModelPromises, _a, sceTypeIdToAssetCriticalityTypeId, hasUpdates_1, promises, criticalityModels, mappingPromises, criticalityCompressedModelPromises, mappingPromises;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        Permissions_1.rbacPermissions.verifyObjectWritePermission();
                        return [4 /*yield*/, this.getAssetCriticalityMappings()];
                    case 1:
                        mappings = _b.sent();
                        if (!(mappings.length === 0)) return [3 /*break*/, 9];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 6, , 7]);
                        return [4 /*yield*/, this._objectsApi.queryForCompressedModelWithAssetMonitorModel(ModelConstants_1.ModelConstants.SceModel, ModelConstants_1.ModelConstants.AssetCriticalityModel)];
                    case 3:
                        infoModelCriticalityModels = _b.sent();
                        if (!(infoModelCriticalityModels.data.data.length > 0)) return [3 /*break*/, 5];
                        criticalityCompressedModelPromises = lodash_1.map(infoModelCriticalityModels.data.data, function (data) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var criticalityCompressedModel;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        criticalityCompressedModel = SceCompressedModel_1.SceCompressedModel.fromJson(data, false);
                                        if (!Permissions_1.rbacPermissions.rbacPermissions.isObjectDelete) return [3 /*break*/, 2];
                                        return [4 /*yield*/, criticalityCompressedModel.deleteCompressedModelFromInfoModel()];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(criticalityCompressedModelPromises)];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        _a = _b.sent();
                        return [3 /*break*/, 7];
                    case 7: return [4 /*yield*/, SceModel_1.SceModel.createSceModelsFromTypeReg()];
                    case 8:
                        _b.sent();
                        return [3 /*break*/, 18];
                    case 9:
                        sceTypeIdToAssetCriticalityTypeId = [];
                        sceTypeIdToAssetCriticalityTypeId.push({
                            key: ModelConstants_1.ModelConstants.AssetCriticalitySceModelTypeATypeId,
                            value: ModelConstants_1.ModelConstants.AssetCriticalityATypeId,
                        });
                        sceTypeIdToAssetCriticalityTypeId.push({
                            key: ModelConstants_1.ModelConstants.AssetCriticalitySceModelTypeBTypeId,
                            value: ModelConstants_1.ModelConstants.AssetCriticalityBTypeId,
                        });
                        sceTypeIdToAssetCriticalityTypeId.push({
                            key: ModelConstants_1.ModelConstants.AssetCriticalitySceModelTypeCTypeId,
                            value: ModelConstants_1.ModelConstants.AssetCriticalityCTypeId,
                        });
                        sceTypeIdToAssetCriticalityTypeId.push({
                            key: ModelConstants_1.ModelConstants.AssetCriticalitySceModelTypeDTypeId,
                            value: ModelConstants_1.ModelConstants.AssetCriticalityDTypeId,
                        });
                        hasUpdates_1 = false;
                        promises = lodash_1.map(sceTypeIdToAssetCriticalityTypeId, function (typeId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var versionsResponse, typeVersions, latestVersion, sceInfoModelObjectResponse;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this._typesApi.getTypeVersions(ModelConstants_1.ModelConstants.AssetCriticalityModel, typeId.value, false)];
                                    case 1:
                                        versionsResponse = _a.sent();
                                        typeVersions = versionsResponse.data.versions;
                                        latestVersion = typeVersions[typeVersions.length - 1];
                                        return [4 /*yield*/, this._objectsApi.queryForCompressedModelWithAssetMonitorAndVersion(ModelConstants_1.ModelConstants.SceModel, ModelConstants_1.ModelConstants.AssetCriticalityModel, typeId.value, latestVersion)];
                                    case 2:
                                        sceInfoModelObjectResponse = _a.sent();
                                        if (sceInfoModelObjectResponse.data.data.length === 0) {
                                            hasUpdates_1 = true;
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 10:
                        _b.sent();
                        return [4 /*yield*/, this._objectsApi.queryForCompressedModelWithAssetMonitorModel(ModelConstants_1.ModelConstants.SceModel, ModelConstants_1.ModelConstants.AssetCriticalityModel)];
                    case 11:
                        criticalityModels = _b.sent();
                        if (!(hasUpdates_1 || criticalityModels.data.data.length > 4)) return [3 /*break*/, 18];
                        if (!(hasUpdates_1 && Permissions_1.rbacPermissions.rbacPermissions.isObjectDelete)) return [3 /*break*/, 13];
                        mappingPromises = lodash_1.map(mappings, function (mapping) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var mappingModel;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        mappingModel = MappingModel_1.MappingModel.fromJson(mapping);
                                        return [4 /*yield*/, mappingModel.deleteAllModels()];
                                    case 1:
                                        _a.sent();
                                        return [4 /*yield*/, mappingModel.deleteMappings()];
                                    case 2:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(mappingPromises)];
                    case 12:
                        _b.sent();
                        return [3 /*break*/, 16];
                    case 13:
                        if (!Permissions_1.rbacPermissions.rbacPermissions.isObjectDelete) return [3 /*break*/, 16];
                        criticalityCompressedModelPromises = lodash_1.map(criticalityModels.data.data, function (data) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var criticalityCompressedModel;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        criticalityCompressedModel = SceCompressedModel_1.SceCompressedModel.fromJson(data, false);
                                        return [4 /*yield*/, criticalityCompressedModel.deleteCompressedModelFromInfoModel()];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        mappingPromises = lodash_1.map(mappings, function (mapping) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var mappingModel;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        mappingModel = MappingModel_1.MappingModel.fromJson(mapping);
                                        return [4 /*yield*/, mappingModel.deleteMappings()];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(criticalityCompressedModelPromises)];
                    case 14:
                        _b.sent();
                        return [4 /*yield*/, Promise.all(mappingPromises)];
                    case 15:
                        _b.sent();
                        _b.label = 16;
                    case 16: return [4 /*yield*/, SceModel_1.SceModel.createSceModelsFromTypeReg()];
                    case 17:
                        _b.sent();
                        _b.label = 18;
                    case 18: return [2 /*return*/];
                }
            });
        });
    };
    SceType.prototype.getAssetCriticalityMappings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var types, objectTypeVersions, versions, objects, mappings;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        types = new Types_1.Types();
                        return [4 /*yield*/, types.getTypeVersions(ModelConstants_1.ModelConstants.AssetCriticalityObjectTypeModel, ModelConstants_1.ModelConstants.AssetCriticalityObjectTypeTypeId)];
                    case 1:
                        objectTypeVersions = _a.sent();
                        versions = objectTypeVersions.data.versions;
                        objects = new Objects_1.Objects();
                        return [4 /*yield*/, objects.getMappingsByVersion(ModelConstants_1.ModelConstants.MappingModel, ModelConstants_1.ModelConstants.AssetCriticalityObjectTypeTypeId, versions[versions.length - 1])];
                    case 2:
                        mappings = _a.sent();
                        return [2 /*return*/, mappings.data.data];
                }
            });
        });
    };
    SceType.prototype.createModel = function (saveOption, model, sceModel, mappingModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(saveOption === "Published")) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.createPublishModel(model, sceModel, mappingModel)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.createDraftModel(model, sceModel, mappingModel)];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        result = _a;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.updateModel = function (saveOption, model, sceModel, mappingModel, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var previousSaveOption, _a, result, result, result, result;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        previousSaveOption = mappingModel.properties.getSaveOption(sceModel.objectId);
                        _a = saveOption;
                        switch (_a) {
                            case "Published": return [3 /*break*/, 1];
                            case "Draft": return [3 /*break*/, 6];
                        }
                        return [3 /*break*/, 11];
                    case 1:
                        if (!(previousSaveOption && previousSaveOption === "Published")) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.updatePublishedWithPublished(model, sceModel, isCod)];
                    case 2:
                        result = _b.sent();
                        return [2 /*return*/, result];
                    case 3:
                        if (!(previousSaveOption && previousSaveOption === "Draft")) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.updateDraftWithPublished(model, sceModel, mappingModel)];
                    case 4:
                        result = _b.sent();
                        return [2 /*return*/, result];
                    case 5: throw new Error("Failed to match save option");
                    case 6:
                        if (!(previousSaveOption && previousSaveOption === "Published")) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.updatePublishedWithDraft(model, sceModel, mappingModel, isCod)];
                    case 7:
                        result = _b.sent();
                        return [2 /*return*/, result];
                    case 8:
                        if (!(previousSaveOption && previousSaveOption === "Draft")) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.updateDraftWithDraft(model, sceModel)];
                    case 9:
                        result = _b.sent();
                        return [2 /*return*/, result];
                    case 10: throw new Error("Failed to match save option");
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    SceType.prototype.createPublishModel = function (model, sceModel, mappingModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var clone, compressedSceModel, response, error_12, model_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clone = DeepCopy_1.deepCopy(sceModel.rawJson);
                        delete clone.objectId;
                        delete clone.version;
                        compressedSceModel = SceCompressedModel_1.SceCompressedModel.createSceCompressedJson([SceModel_1.SceModel.clearNonOverriddenConditions(clone)], false);
                        return [4 /*yield*/, compressedSceModel.saveCompressedModel(false)];
                    case 1:
                        response = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 6]);
                        return [4 /*yield*/, sceModel.saveComputeModel()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        error_12 = _a.sent();
                        model_1 = sceModel.properties.model;
                        return [4 /*yield*/, this._enggModelApi.DeleteEnggModel(response.data.objectId, sceModel.model, model_1.model.value, model_1.typeId.value)];
                    case 5:
                        _a.sent();
                        throw error_12;
                    case 6:
                        sceModel.objectId = response.data.objectId;
                        mappingModel.properties.addType(response.data.objectId, "Published", sceModel.properties.model.model.value);
                        if (!mappingModel.objectId) return [3 /*break*/, 8];
                        return [4 /*yield*/, mappingModel.updateMappings()];
                    case 7:
                        _a.sent();
                        return [3 /*break*/, 10];
                    case 8: return [4 /*yield*/, mappingModel.saveMappings()];
                    case 9:
                        _a.sent();
                        _a.label = 10;
                    case 10: return [2 /*return*/, this.createSceModelResult(model, response.status, sceModel.objectId, 1)];
                }
            });
        });
    };
    SceType.prototype.createDraftModel = function (model, sceModel, mappingModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var clone, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clone = DeepCopy_1.deepCopy(model);
                        delete clone[Field_1.FIELD.OBJECTID];
                        delete clone[Field_1.FIELD.VERSION];
                        return [4 /*yield*/, sceModel.saveSceModelAsDraft(SceModel_1.SceModel.clearNonOverriddenConditions(clone))];
                    case 1:
                        response = _a.sent();
                        mappingModel.properties.addType(response.data.objectId, "Draft", sceModel.properties.model.model.value);
                        if (!mappingModel.objectId) return [3 /*break*/, 3];
                        return [4 /*yield*/, mappingModel.updateMappings()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, mappingModel.saveMappings()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/, this.createSceModelResult(model, response.status, response.data.objectId, 1)];
                }
            });
        });
    };
    SceType.prototype.updateDraftModel = function (model, sceModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var clone, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clone = DeepCopy_1.deepCopy(model);
                        return [4 /*yield*/, sceModel.updateDraftFromSceModel(SceModel_1.SceModel.clearNonOverriddenConditions(clone))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.createSceModelResult(model, response.status, clone.objectId, clone.version + 1)];
                }
            });
        });
    };
    SceType.prototype.updatePublishedWithPublished = function (model, sceModel, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var compressedSceModel, response, _a, version;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // Delete model from cosmosDb, if available. This try catch code can be removed when all models from cosmos db will be empty.
                        try {
                            if (!isCod) {
                                // await this._cosmosDbApi.deleteModel(
                                //   sceModel.objectId,
                                //   ModelConstants.SceModel,
                                //   sceModel.properties.model.model.value
                                // );
                                // sceModel.renewRawJson(); // Purpose: If current version is in cosmos db,
                                // no data will be available in info model/ global storage. So new json (with no version) should be stored to IM/GS
                            }
                        }
                        catch (_c) {
                            // Ignore. The model already is in info model.
                        }
                        compressedSceModel = SceCompressedModel_1.SceCompressedModel.createSceCompressedJson([SceModel_1.SceModel.clearNonOverriddenConditions(DeepCopy_1.deepCopy(sceModel.rawJson))], false);
                        if (!sceModel.rawJson[Field_1.FIELD.VERSION]) return [3 /*break*/, 2];
                        return [4 /*yield*/, compressedSceModel.updateCompressedModel(false)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, compressedSceModel.saveCompressedModel(false)];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        response = _a;
                        return [4 /*yield*/, sceModel.saveComputeModel()];
                    case 5:
                        _b.sent();
                        version = sceModel.version;
                        return [2 /*return*/, this.createSceModelResult(model, response.status, sceModel.objectId, version + 1)];
                }
            });
        });
    };
    /**
     * * Delete sce model instance from cloud.
     * * Delete published computeType json
     * * Create new Draft
     * * Adds draft id to mappings
     * * UpdateMappings
     */
    SceType.prototype.updatePublishedWithDraft = function (model, sceModel, mappingModel, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, model_2, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 7]);
                        return [4 /*yield*/, this._objectsApi.deleteObject(sceModel.objectId, sceModel.model)];
                    case 1:
                        _c.sent();
                        return [3 /*break*/, 7];
                    case 2:
                        _a = _c.sent();
                        _c.label = 3;
                    case 3:
                        _c.trys.push([3, 5, , 6]);
                        model_2 = sceModel.properties.model;
                        return [4 /*yield*/, this._enggModelApi.DeleteEnggModel(sceModel.objectId, sceModel.model, model_2.model.value, model_2.typeId.value)];
                    case 4:
                        _c.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        _b = _c.sent();
                        if (!isCod) {
                            // await this._cosmosDbApi.deleteModel(
                            //   sceModel.objectId,
                            //   sceModel.model,
                            //   sceModel.properties.model.model.value
                            // );
                        }
                        else {
                            throw new Error("Type not available");
                        }
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 7];
                    case 7:
                        mappingModel.properties.removeType(sceModel.objectId);
                        return [4 /*yield*/, this.createDraftModel(model, sceModel, mappingModel)];
                    case 8: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    /**
     * * Deletes previous draft and creates a new one
     * * Deletes previous draft id from mappings and adds new draft id
     * * Update mappings
     */
    SceType.prototype.updateDraftWithDraft = function (model, sceModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateDraftModel(model, sceModel)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SceType.prototype.updateDraftWithPublished = function (model, sceModel, mappingModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        mappingModel.properties.removeType(sceModel.objectId);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 5]);
                        return [4 /*yield*/, this._objectsApi.deleteObject(sceModel.objectId, ModelConstants_1.ModelConstants.ComputeDraftModel)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        _a = _b.sent();
                        return [4 /*yield*/, this._enggModelApi.DeleteEnggModel(sceModel.objectId, ModelConstants_1.ModelConstants.ComputeDraftModel)];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 5: return [4 /*yield*/, this.createPublishModel(model, sceModel, mappingModel)];
                    case 6: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    SceType.prototype.deleteModelWithRelatedType = function (sceModel, mappingModel, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var saveOption, _a, result_1, model, _b, _c, result;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        saveOption = sceModel.properties.saveOption;
                        if (!(saveOption === "Draft")) return [3 /*break*/, 7];
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 5]);
                        return [4 /*yield*/, this._objectsApi.deleteObject(sceModel.objectId, ModelConstants_1.ModelConstants.ComputeDraftModel)];
                    case 2:
                        _d.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        _a = _d.sent();
                        return [4 /*yield*/, this._enggModelApi.DeleteEnggModel(sceModel.objectId, ModelConstants_1.ModelConstants.ComputeDraftModel)];
                    case 4:
                        _d.sent();
                        return [3 /*break*/, 5];
                    case 5: return [4 /*yield*/, this.updateOrDeleteMappings(mappingModel)];
                    case 6:
                        _d.sent();
                        result_1 = {
                            status: 200,
                            details: "Deleted",
                        };
                        return [2 /*return*/, result_1];
                    case 7:
                        model = sceModel.properties.model;
                        _d.label = 8;
                    case 8:
                        _d.trys.push([8, 14, , 15]);
                        _d.label = 9;
                    case 9:
                        _d.trys.push([9, 11, , 13]);
                        return [4 /*yield*/, this._objectsApi.deleteObject(sceModel.objectId, ModelConstants_1.ModelConstants.SceModel)];
                    case 10:
                        _d.sent();
                        return [3 /*break*/, 13];
                    case 11:
                        _b = _d.sent();
                        return [4 /*yield*/, this._enggModelApi.DeleteEnggModel(sceModel.objectId, sceModel.model, model.model.value, model.typeId.value)];
                    case 12:
                        _d.sent();
                        return [3 /*break*/, 13];
                    case 13: return [3 /*break*/, 15];
                    case 14:
                        _c = _d.sent();
                        if (!isCod) {
                            // await this._cosmosDbApi.deleteModel(
                            //   sceModel.objectId,
                            //   sceModel.model,
                            //   model.model.value
                            // );
                        }
                        else {
                            throw new Error("Failed to delete Type");
                        }
                        return [3 /*break*/, 15];
                    case 15: return [4 /*yield*/, this.updateOrDeleteMappings(mappingModel)];
                    case 16:
                        _d.sent();
                        result = {
                            status: 200,
                            details: "Deleted",
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceType.prototype.updateOrDeleteMappings = function (mappingModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(mappingModel.properties.sceEngModels.length === 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, mappingModel.deleteMappings()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, mappingModel.updateMappings()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceType.prototype.fetchModelsForMappingFiles = function (mappingModels) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var modelsObjectsInfo, draftsObjectsInfo;
            return tslib_1.__generator(this, function (_a) {
                modelsObjectsInfo = [];
                draftsObjectsInfo = [];
                lodash_1.map(mappingModels, function (mappingModel) {
                    lodash_1.map(mappingModel.properties.sceEngModels, function (sceEngModel) {
                        if (sceEngModel.state.value === "Published") {
                            modelsObjectsInfo.push({
                                objectId: sceEngModel.id,
                                modelId: ModelConstants_1.ModelConstants.SceModel,
                                assetMonitorModelId: sceEngModel.model.value,
                            });
                        }
                        else {
                            draftsObjectsInfo.push({
                                objectId: sceEngModel.id,
                                modelId: ModelConstants_1.ModelConstants.ComputeDraftModel,
                                assetMonitorModelId: sceEngModel.model.value,
                            });
                        }
                    });
                });
                return [2 /*return*/, Object.freeze([modelsObjectsInfo, draftsObjectsInfo])];
            });
        });
    };
    SceType.prototype.fetchSceModels = function (objectsInfo, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sceModels, models, nonEmptyModels;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sceModels = lodash_1.map(objectsInfo, function (objectInfo) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var sceObjectFromInfoModel, _a, sceCompressedModel, json, _b;
                            return tslib_1.__generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        _c.trys.push([0, 6, , 7]);
                                        sceObjectFromInfoModel = void 0;
                                        _c.label = 1;
                                    case 1:
                                        _c.trys.push([1, 3, , 5]);
                                        return [4 /*yield*/, this._enggModelApi.GetEnggModel(objectInfo.objectId, objectInfo.modelId)];
                                    case 2:
                                        sceObjectFromInfoModel = _c.sent();
                                        return [3 /*break*/, 5];
                                    case 3:
                                        _a = _c.sent();
                                        return [4 /*yield*/, this._objectsApi.getObject(objectInfo.objectId, objectInfo.modelId)];
                                    case 4:
                                        sceObjectFromInfoModel = _c.sent();
                                        return [3 /*break*/, 5];
                                    case 5:
                                        sceCompressedModel = SceCompressedModel_1.SceCompressedModel.fromJson(sceObjectFromInfoModel.data, false);
                                        json = sceCompressedModel.properties.getUncompressedModel(objectInfo.assetMonitorModelId);
                                        json[Field_1.FIELD.OBJECTID] = sceCompressedModel.objectId;
                                        json[Field_1.FIELD.VERSION] = sceCompressedModel.version;
                                        return [2 /*return*/, json];
                                    case 6:
                                        _b = _c.sent();
                                        return [2 /*return*/, {}];
                                    case 7: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(sceModels)];
                    case 1:
                        models = _a.sent();
                        nonEmptyModels = lodash_1.filter(models, function (model) {
                            return !lodash_1.isEmpty(model);
                        });
                        return [2 /*return*/, nonEmptyModels];
                }
            });
        });
    };
    SceType.prototype.fetchDraftModels = function (objectsInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var draftsPromises, drafts, nonEmptyDrafts;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        draftsPromises = lodash_1.map(objectsInfo, function (objectInfo) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var draft, _a, content, _b;
                            return tslib_1.__generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        _c.trys.push([0, 6, , 7]);
                                        draft = void 0;
                                        _c.label = 1;
                                    case 1:
                                        _c.trys.push([1, 3, , 5]);
                                        return [4 /*yield*/, this._enggModelApi.GetEnggModel(objectInfo.objectId, objectInfo.modelId)];
                                    case 2:
                                        draft = _c.sent();
                                        return [3 /*break*/, 5];
                                    case 3:
                                        _a = _c.sent();
                                        return [4 /*yield*/, this._objectsApi.getObject(objectInfo.objectId, objectInfo.modelId)];
                                    case 4:
                                        draft = _c.sent();
                                        return [3 /*break*/, 5];
                                    case 5:
                                        content = Draft_1.Draft.fromJson(draft.data).getDraftContent();
                                        content[Field_1.FIELD.OBJECTID] = objectInfo.objectId;
                                        content[Field_1.FIELD.VERSION] = 1;
                                        return [2 /*return*/, content];
                                    case 6:
                                        _b = _c.sent();
                                        return [2 /*return*/, {}];
                                    case 7: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(draftsPromises)];
                    case 1:
                        drafts = _a.sent();
                        nonEmptyDrafts = lodash_1.filter(drafts, function (draft) {
                            return !lodash_1.isEmpty(draft);
                        });
                        return [2 /*return*/, nonEmptyDrafts];
                }
            });
        });
    };
    SceType.prototype.getTenantSpecificZippedModel = function (zippedModel) {
        var tenantSpecificZippedModel = DeepCopy_1.deepCopy(zippedModel);
        var updatedFunctionTypeTypeIds = [];
        lodash_1.map(tenantSpecificZippedModel.functionTypes, function (functionType) {
            var jsonTags = functionType[Field_1.FIELD.TAGS]
                ? functionType[Field_1.FIELD.TAGS]
                : [];
            var functionTypeId = DeepCopy_1.deepCopy(functionType[Field_1.FIELD.TYPEID]);
            var updatedFunctionTypeId = Helper_1.Helper.updateTenantSpecificTypeId(functionTypeId, jsonTags, false);
            if (updatedFunctionTypeId !== functionType[Field_1.FIELD.TYPEID]) {
                updatedFunctionTypeTypeIds.push(DeepCopy_1.deepCopy(functionType[Field_1.FIELD.TYPEID]));
            }
            functionType[Field_1.FIELD.TYPEID] = updatedFunctionTypeId;
            functionType[Field_1.FIELD.TAGS] = Helper_1.Helper.updateTenantSpecificTags(jsonTags);
        });
        var amFunctions = tenantSpecificZippedModel.model.properties
            .functions;
        var updatedFunctions = {};
        lodash_1.map(Object.keys(amFunctions), function (functionName) {
            var amFunction = amFunctions[functionName];
            var functionTypeValue = amFunction[Field_1.FIELD.FUNCTIONTYPE][Field_1.FIELD.VALUE];
            var typeId = functionTypeValue.split("@");
            if (updatedFunctionTypeTypeIds.includes(typeId[0])) {
                var updatedTypeId = Helper_1.Helper.updateTenantSpecificTypeId(typeId[0], [], true);
                typeId[0] = updatedTypeId;
                amFunction[Field_1.FIELD.FUNCTIONTYPE][Field_1.FIELD.VALUE] = typeId.join("@");
            }
            updatedFunctions[functionName] = amFunction;
        });
        tenantSpecificZippedModel.model.properties.functions = updatedFunctions;
        var amTypeId = tenantSpecificZippedModel.model.properties
            .model.typeId.value;
        var amTags = tenantSpecificZippedModel.model.properties
            .model.tags.value;
        tenantSpecificZippedModel.model.properties.model.typeId.value = Helper_1.Helper.updateTenantSpecificTypeId(amTypeId, amTags, false);
        tenantSpecificZippedModel.model.properties.model.tags.value = Helper_1.Helper.updateTenantSpecificTags(amTags);
        return tenantSpecificZippedModel;
    };
    SceType.prototype.getUniqueFunctionTypes = function (functionTypes) {
        var uniqueTypes = [];
        lodash_1.map(functionTypes, function (functionType) {
            var filteredFunctionType = lodash_1.find(uniqueTypes, function (uniqueType) {
                return (uniqueType.typeId === functionType.typeId &&
                    uniqueType.version === functionType.version);
            });
            if (!filteredFunctionType) {
                uniqueTypes.push(functionType);
            }
        });
        return uniqueTypes;
    };
    SceType.prototype.createSceModelResult = function (model, status, objectId, modelVersion) {
        var resultDetails = DeepCopy_1.deepCopy(model);
        resultDetails.objectId = objectId;
        resultDetails.version = modelVersion;
        var result = {
            status: status,
            details: resultDetails,
        };
        return result;
    };
    SceType.prototype.createSceModelListResult = function (data) {
        var result = {
            status: 200,
            details: data,
        };
        return result;
    };
    SceType.prototype.handleSceTypeError = function (error) {
        var exceptionHandler = new ExceptionHandler_1.ExceptionHandler();
        return JSON.stringify(exceptionHandler.buildExceptionFromError(error));
    };
    SceType.prototype.handleServerError = function (error) {
        var exceptionHandler = new ExceptionHandler_1.ExceptionHandler();
        return JSON.stringify(exceptionHandler.parseError(error));
    };
    return SceType;
}());
exports.SceType = SceType;
//# sourceMappingURL=SceType.js.map